'use strict';

module.exports = [
  'a',
  'abbr',
  'acronym',
  'b',
  'br',
  'code',
  'em',
  'font',
  'i',
  'img',
  'ins',
  'kbd',
  'map',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
];
